import revive_payload_client_4sVQNw7RlN from "/Users/taichi.anzo/work/DandS/chirashi-viewer/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/Users/taichi.anzo/work/DandS/chirashi-viewer/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Users/taichi.anzo/work/DandS/chirashi-viewer/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/Users/taichi.anzo/work/DandS/chirashi-viewer/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/Users/taichi.anzo/work/DandS/chirashi-viewer/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/Users/taichi.anzo/work/DandS/chirashi-viewer/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/Users/taichi.anzo/work/DandS/chirashi-viewer/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/Users/taichi.anzo/work/DandS/chirashi-viewer/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/Users/taichi.anzo/work/DandS/chirashi-viewer/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import breakpoints_AXORAsvJyN from "/Users/taichi.anzo/work/DandS/chirashi-viewer/plugins/breakpoints.js";
import gtm_MVzSxF8h1r from "/Users/taichi.anzo/work/DandS/chirashi-viewer/plugins/gtm.js";
import msw_bgQn2obvW3 from "/Users/taichi.anzo/work/DandS/chirashi-viewer/plugins/msw.js";
import router_19BuzgFWKZ from "/Users/taichi.anzo/work/DandS/chirashi-viewer/plugins/router.js";
import sentry_client_GoGQuZo4Et from "/Users/taichi.anzo/work/DandS/chirashi-viewer/plugins/sentry.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  check_outdated_build_client_8vK7RkfGxZ,
  breakpoints_AXORAsvJyN,
  gtm_MVzSxF8h1r,
  msw_bgQn2obvW3,
  router_19BuzgFWKZ,
  sentry_client_GoGQuZo4Et
]